import { useContext } from 'react';

import { focusedViewContext } from 'src/modules/renderings/provider';

const useFocusedView = () => useContext(focusedViewContext);

export { useFocusedView };
